import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'app-file-picker',
  templateUrl: './file-picker.component.html',
  styleUrls: ['./file-picker.component.scss'],
})
export class FilePickerComponent {
  getFile() {
    if (!this.fileUrl) {
      return 'none';
    }
    return `url('${this.fileUrl}')`;
  }

  @Input() fileUrl: undefined | string;
  @Output() onFileChanged = new EventEmitter();
  fileSelected(e: any) {
    this.onFileChanged.emit(e);
  }

  @Output() onFileDeleted = new EventEmitter();
  fileDeleted() {
    this.onFileDeleted.emit();
  }
}
